(() => {
  if (window.__luxDiscountInit) return;
  window.__luxDiscountInit = true;

  function parseMoney(text) {
    if (!text) return null;
    const cleaned = text.replace(/\s/g, "").replace(/[^\d.,-]/g, "");
    if (!cleaned) return null;

    const hasComma = cleaned.includes(",");
    const hasDot = cleaned.includes(".");
    let normalized = cleaned;

    if (hasComma && hasDot) {
      normalized =
        cleaned.lastIndexOf(".") > cleaned.lastIndexOf(",")
          ? cleaned.replace(/,/g, "")
          : cleaned.replace(/\./g, "").replace(",", ".");
    } else if (hasComma && !hasDot) {
      const parts = cleaned.split(",");
      normalized =
        parts[parts.length - 1].length === 2
          ? cleaned.replace(/\./g, "").replace(",", ".")
          : cleaned.replace(/,/g, "");
    } else {
      normalized = cleaned.replace(/,/g, "");
    }

    const n = Number(normalized);
    return Number.isFinite(n) ? n : null;
  }

  function upsert(priceListEl) {
    const saleEl = priceListEl.querySelector("sale-price");
    const compareEl = priceListEl.querySelector("compare-at-price");
    const existing = priceListEl.querySelector(".lux-discount-percent");

    if (!saleEl || !compareEl) {
      if (existing) existing.remove();
      return;
    }

    const sale = parseMoney(saleEl.textContent);
    const compare = parseMoney(compareEl.textContent);

    if (!sale || !compare || compare <= sale) {
      if (existing) existing.remove();
      return;
    }

    const percent = Math.round(((compare - sale) / compare) * 100);
    if (!percent || percent <= 0) return;

    let badge = existing;
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "lux-discount-percent";
      compareEl.insertAdjacentElement("afterend", badge);
    }
    badge.textContent = `${percent}% off`;
  }

  function runAll() {
    document.querySelectorAll("price-list").forEach(upsert);
  }

  // Debounce so we never run too frequently
  let t = null;
  function scheduleRun() {
    if (t) return;
    t = setTimeout(() => {
      t = null;
      runAll();
    }, 80);
  }

  // Initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runAll, { once: true });
  } else {
    runAll();
  }

  // Prestige variant changes (best signal)
  document.addEventListener("variant:changed", scheduleRun);

  // Light observer: ONLY watch for added/removed nodes (no characterData)
  const obs = new MutationObserver(() => scheduleRun());
  obs.observe(document.body, { childList: true, subtree: true });
})();